export default __webpack_public_path__ + "static/media/homepage.94b97486.webp";